import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { StylesheetGroupsService } from '../../../services/stylesheet/stylesheet-groups.service';
import { NotyService } from '../../../services/common/noty.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-stylesheet-groups',
  templateUrl: './stylesheet-groups.component.html',
  styleUrls: ['./stylesheet-groups.component.scss'],
})
export class StylesheetGroupsComponent implements OnInit {
  constructor(private styleSheetGroupsService: StylesheetGroupsService, private router: Router, private route: ActivatedRoute, private notyService: NotyService) {}
  searchTerm: String = '';
  styleSheetGroups: Array<any> = [];
  styleSheetGroupsMaxCount: number;
  styleSheetGroupFormInput: String = '';
  styleSheetGroupId: Number;
  shouldEdit: Boolean = false;
  isCreating: Boolean = false;
  isUpdating: Boolean = false;
  isDeleting: Boolean = false;
  paginateParams: any = {
    page: 1,
    per_page: 5,
  };
  ngOnInit(): void {
    this.styleSheetGroupsService
      .searchOptions({ angular: true, search_options: true })
      .then((success) => {
        this.paginateParams.per_page = success.per_page;
        console.log('searchOptions success', success);
        this.loadStyleSheetGroups();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  loadStyleSheetGroups(pageEvent: any = null) {
    this.styleSheetGroupFormInput = '';
    this.shouldEdit = false;
    if (pageEvent) this.paginateParams.page = pageEvent.page;
    let { page, per_page } = this.paginateParams;
    this.styleSheetGroupsService
      .index({ angular: true, page, per_page })
      .then((response_json) => {
        response_json.stylesheet_groups.forEach((stylesheet_group: any) => {
          stylesheet_group.isDeleting = false;
        });
        this.styleSheetGroups = response_json.stylesheet_groups;
        this.styleSheetGroupsMaxCount = response_json.totalCount;
        console.log('styleSheetGroups response', response_json);
      })
      .catch((error) => {
        console.log('error', error);
      });
  };

  getstyleSheetGroupFormInput(event: any) {
    this.styleSheetGroupFormInput = event.target.value;
  };

  deleteStyleSheetGroup(id: number, styleSheetGroup: any) {
    styleSheetGroup.isDeleting = true;
    this.styleSheetGroupsService
      .delete({ id })
      .then((deleteResponse) => {
        console.log('deleteResponse', deleteResponse);
        this.notyService.notify('Stylesheet Group Deleted', 'success');
        styleSheetGroup.isDeleting = false;
        this.loadStyleSheetGroups();
      })
      .catch((deleteError) => {
        console.log(deleteError);
      });
  };

  createStyleSheetGroup() {
    if (this.styleSheetGroupFormInput) {
      this.isCreating = true;
      console.log('createStyleSheetGroup');
      this.styleSheetGroupsService
        .create({ name: this.styleSheetGroupFormInput })
        .then((createResponse) => {
          console.log('createResponse', createResponse);
          this.notyService.notify('Stylesheet Group Created', 'success');
          this.isCreating = false;
          this.loadStyleSheetGroups();
        })
        .catch((deleteError) => {
          console.log(deleteError);
        });
    }
  };

  updateStyleSheetGroup(styleSheetGroupId: number, styleSheetGroupName: any) {
    this.shouldEdit = true;
    this.styleSheetGroupFormInput = styleSheetGroupName;
    this.styleSheetGroupId = styleSheetGroupId;
  };

  makeUpdateStyleSheetGroup() {
    this.isUpdating = true;
    this.styleSheetGroupsService
      .update({ id: this.styleSheetGroupId, name: this.styleSheetGroupFormInput })
      .then((updateResponse) => {
        console.log('updateResponse', updateResponse);
        this.notyService.notify('Stylesheet Group Updated', 'success');
        this.isUpdating = false;
        this.loadStyleSheetGroups();
      })
      .catch((updateError) => {
        console.log(updateError);
      });
  };

  setSearchTerm(event: any) {
    this.searchTerm = event.target.value;
  };

  searchStyleSheetGroups(pageEvent: any = null) {
    console.log('searchTerm', this.searchTerm);
    if (pageEvent) this.paginateParams.page = pageEvent.page;
    let { page, per_page } = this.paginateParams;
    this.styleSheetGroupsService
      .index({ angular: true, name: this.searchTerm, page, per_page })
      .then((searchResponse) => {
        console.log('searchResponse', searchResponse);
        this.styleSheetGroups = searchResponse.stylesheet_groups;
        this.styleSheetGroupsMaxCount = searchResponse.totalCount;
      })
      .catch((searchError) => {
        console.log('searchError', searchError);
      });
  };
}
